"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_TTL = 60;
const CACHE_TAG = "SLSCache";
exports.default = new class SLSCache {
    constructor() {
        this.TTL = DEFAULT_TTL;
        this.cacheTag = CACHE_TAG;
        this.mToMs = (minutes) => minutes * 60000;
        this.getTTL = (ttl) => Date.now() + this.mToMs(ttl || this.TTL);
    }
    config(options) {
        const { defaultTTL, cacheName } = options;
        this.TTL = defaultTTL || DEFAULT_TTL;
        this.cacheTag = cacheName || CACHE_TAG;
        this.getIndex();
    }
    getIndex() {
        const index = localStorage.getItem(this.cacheTag);
        if (index) {
            try {
                return JSON.parse(index);
            }
            catch (_a) {
                this.clearCache();
            }
        }
        else {
            localStorage.setItem(this.cacheTag, "{}");
        }
        return this.getIndex();
    }
    clearCache() {
        localStorage.removeItem(this.cacheTag);
        const { length } = localStorage;
        for (let i = 0; i < length; i++) {
            const key = localStorage.key(i);
            if (key === null || key === void 0 ? void 0 : key.startsWith(this.cacheTag + "::")) {
                localStorage.removeItem(key);
            }
        }
    }
    addToIndex(item) {
        const index = this.getIndex();
        index[item.key] = this.getTTL(item.TTL);
        localStorage.setItem(this.cacheTag, JSON.stringify(index));
    }
    removeFromIndex(key) {
        const index = this.getIndex();
        delete index[key];
        localStorage.setItem(this.cacheTag, JSON.stringify(index));
    }
    garbageCollector() {
        const index = this.getIndex();
        for (const item in index) {
            if (Object.prototype.hasOwnProperty.call(index, item)) {
                const ttl = index[item];
                if (ttl < Date.now()) {
                    localStorage.removeItem(`${this.cacheTag}::${item}`);
                    this.removeFromIndex(item);
                }
            }
        }
    }
    set(key, data, TTL) {
        this.garbageCollector();
        this.removeFromIndex(key);
        localStorage.removeItem(key);
        this.addToIndex({ key, TTL });
        localStorage.setItem(`${this.cacheTag}::${key}`, JSON.stringify(data));
    }
    get(key) {
        this.garbageCollector();
        const item = localStorage.getItem(`${this.cacheTag}::${key}`);
        return !!item ? JSON.parse(item) : undefined;
    }
};
//# sourceMappingURL=index.js.map